import React from 'react';
import PastDuePayments from './PastDuePayments';

const PastDuePaymentsData = props => {
  return <PastDuePayments {...props} />;
};

export default PastDuePaymentsData;
